<template>
  <div class="terms-of-use-modal-wrapper">
    <p class="terms-of-use-modal__content-title">Условия проведения электронной закупки ПАО «МТС» на право оказания услуг по транспортно-экспедиторскому обслуживанию и погрузо-разгрузочным работам ТМЦ на телекоммуникационные объекты согласно выставленному Лоту</p>
        
    <p class="terms-of-use-modal__content-title">Термины</p>
    <ol class="terms-of-use-modal__content-list">
      <li>Электронная закупка (электронные торги, далее - Торги) – электронный сбор предложений третьих лиц о стоимости их товаров/работ/услуг (предложение), проводимый посредством сайта teleport.mts.ru в сети Интернет (далее Телепорт);</li>
      <li>ТК - транспортная компания;</li>
      <li>ТЦП - тарифно-ценовой показатель;</li>
      <li>Телепорт - системы для автоматизации, подготовки, анализа и оформления оптимальных вариантов доставки ТМЦ всеми видами транспортных средств по РФ ПАО МТС;</li>
      <li>Стартовые цены для электронных торгов – уровень ТЦП, предоставленный Участнику при информировании об электронных торгах, в соответствии с лотом</li>
    </ol>

    <p class="terms-of-use-modal__content-title">Порядок и способ проведения электронной закупки</p>
    <ol class="terms-of-use-modal__content-list">
      <li>Порядок и форма извещения Участников электронной закупки - письменное уведомление в системе электронных торгов ПАО «МТС»;</li>
      <li>Способ проведения электронной закупки -  электронный аукцион на понижение;</li>
      <li>Основной часовой пояс проведения торгов - Московский, UTC +3:00;</li>
      <li>Торги автоматически продлеваются при условии, что за 5 (пять) минут до завершения торгов была сделана ставка</li>
    </ol>

    <p class="terms-of-use-modal__content-title">Проведение торгов: начало, окончание и продление торгов</p>
    <ol class="terms-of-use-modal__content-list">
      <li>Начало торгов. Торги начинаются с момента получения системного уведомления Телепорта на электронную почту контактного лица от ТК;</li>
      <li>Окончание торгов. Торги заканчиваются в дату и время закрытия, которые указаны в Телепорте;</li>
      <li>Торги проводятся с продлением: шаг продления – 5 (пять) минут. Продление происходит, если была сделана ставка за 5 (пять) минут до завершения торгов;</li>
    </ol>
        
    <p class="terms-of-use-modal__content-text">Пример процедуры торгов и продления на примере завершения торгов в 10:00</p>
    <p class="terms-of-use-modal__content-text">Общее правило: если в течение пяти минут до завершении торгов Участник делает ставку, то торги продлеваются на 5 (пять) минут. </p>
    <p class="terms-of-use-modal__content-text">Например, время окончания торгов 10:00, последняя ставка сделана 09:57:34. В этом случае происходит сдвиг времени окончания торгов на 5 (пять) минут с момента последней ставки. Новое время завершения торгов - 10:02:34. Пример далее - если в 10:01:02 снова сделана ставка, время окончания торгов  до 10:06:02 и т.д.</p>
    <p class="terms-of-use-modal__content-text">При завершении торгов Участник получает письменное электронное уведомление о своем статусе в данном аукционе.</p>
        
    <p class="terms-of-use-modal__content-title">Валюта, цены и шаг ставки</p>
    <ol class="terms-of-use-modal__content-list">
      <li>Валюта. Валюта выставляемых цен – руб. без НДС; </li>
      <li>Цены. Цены должны быть указаны за 1 (одну) единицу измерения работ/услуг без учета НДС 20% в соответствии с ТЦП;</li>
      <li>Стартовая цена. Стартовая цена торгов - 100% принимаемый стартовый уровень цен для каждого ТЦП лота;</li>
      <li>Шаг ставки. Шаг изменения (понижения) цены задается и соответствует указанному шагу в каждом лоте. Делая ставку, Участник указывает свою финальную цену за лот. Пример: стартовая цена лота 100 000 рублей без НДС, шаг ставки 1000 рублей. Следующая ставка с учетом понижения и шага ставки должна быть 99 000 рублей. Без стартовой цены также учитывается шаг понижения, но от лучшей ставки; </li>
      <li>Не разрешается выставление по лоту одинаковых лучших цен несколькими Участниками;</li>
      <li>В процессе проведения торгов Участникам доступна информация о лучшей цене по лоту без наименования Участника, предлагающего данную цену;</li>
      <li>Если вы дали неверную скидку или ставку, то обратитесь к организатору торгов</li>
    </ol>

    <p class="terms-of-use-modal__content-title">Участие в торгах и принятие коммерческого предложения</p>
    <ol class="terms-of-use-modal__content-list">
      <li>Участие в торгах для поставщиков бесплатное;</li>
      <li>Решение о принятии коммерческого предложения по итогам проведенных электронных торгов принимается Заказчиком самостоятельно по совокупности оценочных критериев Участников торгов;</li>
      <li>В течение одного рабочего дня после закрытия электронных торгов Участники должны подтвердить выставленные цены на момент закрытия, прикрепив коммерческое предложение, заверенную подписью руководителя и печатью;</li>
    </ol>
  </div>
</template>

<script>
  export default {

  };
</script>

<style>
  .terms-of-use-modal__content-text {
    font-family: 'MTSSansWebRegular';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-bottom: 8px;
  }

  .terms-of-use-modal__content-title {
    font-family: 'MTSSansWebMedium';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .terms-of-use-modal__content-list {
    margin-top: 0;
  }

  .terms-of-use-modal__content-list li {
    font-family: 'MTSSansWebRegular';
    font-size: 14px;
    line-height: 20px;
    color: var(--color-deep-blue);
    margin-bottom: 8px;
  }
</style>
